export default "__VITE_ASSET__DCjsUbpw__"